<script>
    import searchlogo from '../../../assets/pictures/search.svg'
    export let value = ''
    export let placeholder = 'Buscar'
</script>

<span class="search">
    <img src={searchlogo} alt="" draggable="false" />
    <input type="search" {placeholder} bind:value on:input />
</span>

<style>
    .search {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        padding: 0 25px;
        justify-content: flex-start;
    }
    .search input {
        border-style: none;
        outline: none;
        font-size: 17px;
        width: 100%;
    }
</style>
